import { AccordionHeader, SocReminderCardAccordion, SocReminderCardContainer }
  from "../../../shared/containers/StandardOfCareContainer/SOC.style";
import { AccordionSummary, Box, Button, IconButton, Typography } from "@mui/material";
import { IPetItemResponse, ISOCItemResponse, ISocReminderItems }
  from "../../../services/Standard-of-care/standard-of-care.interface";
import React, { FC, useEffect, useState } from "react";

// import { CloseIcon } from "../../../components/Icons";
import { AvatarCustom } from "../../../components";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { MIXPANEL_EVENTS } from "../../../config/mixPanelEvents";
import { CREATE_BOOKING_TYPE, MODALS } from "../../../config/params";
import SOCChildAccordion from "../../../shared/containers/StandardOfCareContainer/SOCChildAccordion";
import { SOC_ICONS } from "../../../shared/containers/StandardOfCareContainer/StandardOfCareContainer";
import { SocCompleteIcon } from "../../../components/Icons";
import SocCustomAvatar from "../../../shared/containers/StandardOfCareContainer/SocCustomAvatar";
import { connect } from "react-redux";
import { socStatusMapper } from "../../../utils/SOCUtils";
import { useAppointmentStore } from "../../../hooks/redux-hooks/appointment-store/appointment.store";
import { useModal } from "../../../context/ModalContext";
import { useSocDatByPetReminderCard } from "../../../services/Standard-of-care/standard-of-care.service";
import { userActivityLogger } from "../../../utils/mixpanel";
import { useOverdueInvoiceStore } from "../../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import { useBookingAppointmentTypeStore } from "../../../hooks";

interface ISocReminderContainer {
  petIds: string[]
  petList: IPetItemResponse[]
}

const SocReminderContainer: FC<ISocReminderContainer> = (props) => {
  const { getSocDataByPetsForReminderCard, socDataByPet } = useSocDatByPetReminderCard();
  const [expandedChild, setExpandedChild] = useState<string | false>(false);
  const { openModal } = useModal();
  const { pendingPaymentPetList, isBookingBlocked, pausedWellnessPetList, cancelledWellnessPetList } =
  useOverdueInvoiceStore();
  const { setSelectedPets, setReasonForVisit } = useAppointmentStore();
  const [expanded, setExpanded] = useState<string[]>([]);
  const { bookingAppointmentType } = useBookingAppointmentTypeStore();

  const handleChangeChild = (panel: string) =>
    (event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedChild(isExpanded ? panel : false);
    };

  const handleChange = (panel: string) => (event: React.SyntheticEvent, newExpanded: boolean) => {
    setExpanded((prevExpanded) => {
      // eslint-disable-next-line no-unused-vars
      const [panelType, panelId] = panel.split("_");

      const updatedExpanded = prevExpanded.filter((item) => !item.endsWith(`_${panelId}`));

      if (newExpanded) {
        updatedExpanded.push(panel);
      }

      return updatedExpanded;
    });
  };

  useEffect(() => {
    if (props.petIds.length) {
      getSocDataByPetsForReminderCard(props.petIds);
    }
  }, [props.petIds]);

  useEffect(() => {
    if (socDataByPet) {
      const allPanelIds = props.petIds.flatMap((id) =>
        Object.keys(socDataByPet.find((socData) =>
          socData.animalId == id)?.items || {}).slice(1, 4)
          .filter((title) => title.includes("diagnostic")) .map((title) => title + "_" + id),
      );

      setExpanded(allPanelIds);
    }
  }, [socDataByPet, props.petIds]);

  const getPetData = (id: string) => {
    return props.petList?.find((pet) => pet.id == id);
  };

  const getSocData = (id: string) => {
    if (socDataByPet) {
      return socDataByPet.find((socData) => socData.animalId == id)?.items;
    }
  };

  const handleBookAppointment = (petData: IPetItemResponse) => {
    if (petData) {
      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT, { start_from: "soc_overdue", pet_name: petData.name,
        appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
        overdue_status: pendingPaymentPetList.length > 0 ? "yes" : "no",
        is_plan_cancelled: cancelledWellnessPetList.length > 0 ? "true" : "false",
      });
      // setSinglePetSelected([petData]);
      setSelectedPets([petData]);
      userActivityLogger(MIXPANEL_EVENTS.BOOK_A_VISIT_SELECT_PET, { no_of_pets: 1,
        owner_type: props.petList?.length==1?"single_pet":"multipet", referred_from: "soc_reminder_card",
        pet_name: petData.name,
        appt_type: bookingAppointmentType === CREATE_BOOKING_TYPE.DROPOFF_BOOKING ? "drop_off" : "in_room_visit",
      });
      setReasonForVisit({ [petData.id]: { reasons: "", anything: " ", socReasons: [] } });
      if (!isBookingBlocked && (pendingPaymentPetList.length > 0)) {
        if (cancelledWellnessPetList.length > 0) {
          openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
        } else if (pausedWellnessPetList.length > 0) {
          openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
        } else {
          openModal(MODALS.GENERIC_PAYMENT_ISSUE_MODAL);
        }
      } else {
        openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
      }
    }
  };

  const getPetReminders = (id: string) => {
    const petData = getPetData(id);
    const socData = getSocData(id);

    const getPendingSocCount = (SOC_STATUS: any) => {
      if (SOC_STATUS["Overdue"] > 0) {
        return { pending: SOC_STATUS["Overdue"], type: "Overdue" };
      } else if (SOC_STATUS["Almost Due"] > 0) {
        return { pending: SOC_STATUS["Almost Due"], type: "Almost Due" };
      } else if (SOC_STATUS["Incomplete"] > 0) {
        return { pending: SOC_STATUS["Incomplete"], type: "Incomplete" };
      } else if (SOC_STATUS["Current"] > 0) {
        return { pending: SOC_STATUS["Current"], type: "Current" };
      } else {
        return undefined;
      }
    };

    function updateSocStatusCount(socItems: any) {
      let pendingSocCount: { pending: string, type: string } | null | undefined = null;

      const SOC_STATUS: any = {
        "Overdue": 0,
        "Incomplete": 0,
        "Current": 0,
        "Almost Due": 0,
      };

      socItems.forEach((item: any) => {
        SOC_STATUS[item.status] += 1;
      });

      pendingSocCount = getPendingSocCount(SOC_STATUS);

      return pendingSocCount;
    }


    const SOC_DATA: ISocReminderItems = {
      "diagnostic": [],
      "vaccination": [],
      "dental": [],
    };

    const finalObject : any = new Map();

    const SOC_KEYS = Object.keys(SOC_DATA);

    SOC_KEYS.forEach((item: any) => {
      finalObject.set(item, socData && socData[item as keyof typeof socData]);
    });

    const socMappedData: Array<[string, ISOCItemResponse[]]> = Array?.from(finalObject);

    const socWithOverDueAndAlmostDue = socMappedData?.filter((item) => item?.[1]?.some((item) =>
      item?.status !== "Current"));


    const allNonEmpty = socData && socData?.dental?.length > 0 &&
     socData?.diagnostic?.length > 0 && socData?.vaccination?.length > 0;

    const allNotCurrent = {
      dental: socData?.dental.some((item) => item?.status === "Overdue" || item?.status === "Almost Due"),
      diagnostic: socData?.diagnostic?.some((item) => item?.status === "Overdue" || item?.status === "Almost Due"),
      vaccination: socData?.vaccination?.some((item) => item?.status === "Overdue" || item?.status === "Almost Due"),
    };
    const hasAnyOverdue = allNotCurrent?.dental || allNotCurrent?.diagnostic || allNotCurrent?.vaccination;

    if (petData && allNonEmpty && hasAnyOverdue) {
      return (
        <>
          <div>
            <SocReminderCardContainer>
              <IconButton
                aria-label="close"
                sx={{ position: "absolute", right: 5, top: 8, color: "gray" }}>
              </IconButton>
              <Box className="child_container">
                <div className="flex gap-3 items-center">
                  <AvatarCustom width={56} height={56} image={petData?.image} name={petData?.name}
                    isWellnessMember={petData?.isWellnessplan}
                    wellnessIconHeight={20} wellnessIconWidth={20}
                  />
                  <Typography variant="h4" fontWeight={600}>{petData?.name} {" "}
                    has important care items that are overdue.</Typography>
                </div>

                <div className="h-min max-h-[15rem] w-full overflow-y-auto">
                  {
                    socData && socWithOverDueAndAlmostDue.map(([title, data], index) => {
                      const panelId = title + "_" + id;

                      return (
                        data && data.length > 0 &&
                        <div key={index}>
                          <SocReminderCardAccordion expanded={expanded.includes(panelId)}
                            onChange={handleChange(panelId)}>
                            <AccordionSummary
                              expandIcon={<ExpandMoreIcon />}
                              aria-controls={`${panelId}d-content`}
                              id={`${panelId}d-header`}
                              className="!pr-3"
                            >
                              <AccordionHeader dynamicStyles={true}>
                                <Box className="title_icon capitalize">
                                  {SOC_ICONS[title]}
                                  <Typography variant="h4" fontWeight={600}>
                                    {title}
                                  </Typography>
                                </Box>
                                <Box>
                                  {updateSocStatusCount(data)?.type === "Current" ? <SocCompleteIcon /> :
                                    <SocCustomAvatar width={24} height={24}
                                      pendingSoc={updateSocStatusCount(data)?.pending}
                                      type={updateSocStatusCount(data)?.type as any} />}
                                </Box>
                              </AccordionHeader>
                            </AccordionSummary>

                            <div id="soc_child_reminder " className="pr-[0.875rem]">
                              {data.map((item: any, i: number) => (
                                (item.status == socStatusMapper.overdue || item.status == socStatusMapper.almostDue) &&
                                (
                                  <SOCChildAccordion
                                    onClick={(item: any) => { }}
                                    isWellnessPlan={false}
                                    key={item.id}
                                    item={item}
                                    expandedChild={expandedChild}
                                    handleChangeChild={handleChangeChild}
                                    dynamicStyles={true}
                                    isBooking={true}
                                    petData={petData}
                                    isDashboard={true}
                                    petID={id}
                                  />
                                )
                              ))}
                            </div>
                          </SocReminderCardAccordion>
                        </div>
                      );
                    })}
                </div>
                <Button
                  variant="contained"
                  id="Book_a_visit_button"
                  color="primary"
                  disabled={isBookingBlocked}
                  fullWidth
                  className="!font-semibold !mt-4 !normal-case"
                  onClick={() => handleBookAppointment(petData)} >
                  Book Appointment </Button>
              </Box>
            </SocReminderCardContainer>
          </div>
        </>
      );
    }

    return (<></>);
  };

  return (
    <>{
      props.petIds.map((petId, index) => {
        return (
          <React.Fragment key={index}>
            {getPetReminders(petId)}
          </React.Fragment>
        );
      })}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return { petList: state.pet.petList };
};

export default connect(mapStateToProps)(SocReminderContainer);
